var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"clearfix mb-0",class:{
      'd-none': _vm.$store.state.studentNotes.isExpanded
    }},[_c('span',{staticClass:"float-md-left d-block d-md-inline-block mt-25 footer-text"},[_vm._v(" "+_vm._s(_vm.$t('COPYRIGHT'))+" © "+_vm._s(new Date().getFullYear())+" "),_c('b-link',{staticClass:"ml-25",attrs:{"href":"#","target":"_blank"}},[_vm._v("GEC")]),_c('span',{staticClass:"d-none d-sm-inline-block"},[_vm._v(", "+_vm._s(_vm.$t('all-rights-reserved')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }